exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer[data-v-1dfc63c0]{margin:100px 0 0!important;background-color:#292929;text-align:center;width:100%}footer>div>address>a[data-v-1dfc63c0],footer>div>address[data-v-1dfc63c0]{color:#e8e8e8;padding:20px 0;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1dfc63c0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Footer.vue
// module id = 38
// module chunks = 0